export class Config {
    public name: string = 'Mat Select';
    public title: string = 'Mat Select';
    public logoUrl: string = '/assets/img/page-logo.png';
    public favIconUrl: string = '/assets/img/favicon-logo.png';
    public emailLogo: string = '';
    public emailLogoAlt: string = '';
    public emailFooterName: string = '';
    public emailFooterEmail: string = '';
    public emailFooterPhone: string = '';
    public primaryColor: string = '#333333';
    public secondaryColor: string = '#FF9E24';
    public retailerId!: number;
}
